module.exports = __webpack_public_path__ + "static/media/Impreza-GE-GH.0f81b388.webp";